import { render, staticRenderFns } from "./AIAssistanceModal.vue?vue&type=template&id=2a70b789&scoped=true&"
import script from "./AIAssistanceModal.vue?vue&type=script&lang=js&"
export * from "./AIAssistanceModal.vue?vue&type=script&lang=js&"
import style0 from "./AIAssistanceModal.vue?vue&type=style&index=0&id=2a70b789&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a70b789",
  null
  
)

export default component.exports